import type { FC } from 'react';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button';

import { LEARN_MORE_URL } from '../constants';
import { useWithButtonAnalytics } from '../hooks/useWithButtonAnalytics';

export const LearnMoreButton: FC<{
	contentId: string;
	renderLocation: string;
	contentType?: string | null;
}> = ({ contentId, renderLocation, contentType }) => {
	const { sendButtonUIEvent } = useWithButtonAnalytics({
		actionSubjectId: 'learnMoreLink',
		contentId,
		renderLocation,
		contentType,
	});

	return (
		<Button href={LEARN_MORE_URL} onClick={sendButtonUIEvent} appearance="link" target="_blank">
			<FormattedMessage
				id="external-share.learn-more.button"
				description="button label text for a CTA to learn more about the highlighted product"
				defaultMessage="Learn More"
			/>
		</Button>
	);
};
